import { useConnectedWallet } from "@terra-money/wallet-provider"
import { networkTypes } from "constants/constants";
import { useChainAddress } from "state/global";

const useChainId = () => {
    const wallet = useConnectedWallet();
    const [network] = useChainAddress("network");

    if ( wallet ) {
        return wallet?.network.chainID;
    } else if ( networkTypes.eth.has(network) ) {
        return process.env.REACT_APP_ETH_CHAIN_ID as string;
    } else if ( networkTypes.bnb.has(network) ) {
        return process.env.REACT_APP_BNB_CHAIN_ID as string;
    };

    return null;
}

export default useChainId;